import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { BusyService } from '../../shared/services/busy.service';
import { AlertService } from '../../shared/services/alert.service';
import { Form, FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginID = null;
  password = '';
  busy = false;
  form: FormGroup;
  constructor(
    private router: Router,
    private authService: AuthService,
    private busyService: BusyService,
    private alertService: AlertService
  ) {
    this.form = new FormGroup({
      login: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required])
    });
    this.busyService.initHandler('loginCmp', busy => {
      this.busy = busy;
    });
  }

  ngOnInit() {}

  singIn() {
    if (!this.form.valid) {
      for (const c in this.form.controls) {
        if (!c) {
          continue;
        }
        const control = this.form.controls[c];
        control.markAsDirty();
      }
      return;
    }

    // if (this.loginID < 0 || !this.password) {
    //   this.alertService.showError(
    //     'Login ID and Password cannnot be empty.',
    //     'Error'
    //   );

    //   return;
    // }

    this.busyService.busy('loginCmp');
    this.authService
      .login(this.loginID, this.password)
      .then(result => {
        if (result === true) {
          this.router.navigate(['/']);
        } else {
          this.alertService.showError(
            'Login ID or Password is incorrect.',
            'Error'
          );
        }
        this.busyService.alive('loginCmp');
      })
      .catch(error => {
        this.busyService.alive('loginCmp');
      });
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/anonymous/login/login.component.ts